var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#5062F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 22C17 22.6904 16.4404 23.25 15.75 23.25C15.0596 23.25 14.5 22.6904 14.5 22C14.5 21.3096 15.0596 20.75 15.75 20.75C16.4404 20.75 17 21.3096 17 22Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 22C23.25 22.6904 22.6904 23.25 22 23.25C21.3096 23.25 20.75 22.6904 20.75 22C20.75 21.3096 21.3096 20.75 22 20.75C22.6904 20.75 23.25 21.3096 23.25 22Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 22C29.5 22.6904 28.9404 23.25 28.25 23.25C27.5596 23.25 27 22.6904 27 22C27 21.3096 27.5596 20.75 28.25 20.75C28.9404 20.75 29.5 21.3096 29.5 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductionIcon);
export default __webpack_public_path__ + "static/media/productionIcon.103ef5406d98a2bc21e8469533364de7.svg";
export { ForwardRef as ReactComponent };